export const ROLES = {
  10: 'ADMIN',
  consumer: 'consumer',
  user: 'USER',
  los: 'LOS',
  vendor: 'vendor',
  admin: 'ADMIN'
}
//
export const SCOPES = {
  canViewCollection: 'can-view-collection',
  canViewReports: 'can-view-reports',
  canViewMIS: 'can-view-mis',
  canViewLeads: 'can-view-leads',
  canViewCMA: 'can-view-cma',
  canViewAdmin: 'can-view-admin',
  canViewInventory: 'can-view-inventory',
  canViewCMATickets: 'can-view-CMA-tickets',
  canViewAD: 'can-view-AD',
  canViewDigitalJourney: 'can-view-digital-journey',
  canViewZohoMIS: 'can-view-Zoho-MIS',
  canViewPDD: 'can-view-pdd',
  canViewBankVerification:'can-view-bank-verification',
  canViewPreOnboarding: 'can-view-pre-onboarding',
  canViewLosDetails: 'can-view-los-details',
  canViewHrForms: 'can-view-hr-forms',
  canViewOpsDocUpload: 'can-view-ops-doc-upload'
}

export const PERMISSIONS = {
  // admin
  10: [
    SCOPES.canViewCollection,
    SCOPES.canViewReports,
    SCOPES.canViewAdmin,
    SCOPES.canViewMIS,
    SCOPES.canViewLeads,
    SCOPES.canViewCMA,
    SCOPES.canViewInventory,
    SCOPES.canViewCMATickets,
    SCOPES.canViewDigitalJourney,
    SCOPES.canViewZohoMIS,
    SCOPES.canViewPDD,
    SCOPES.canViewBankVerification,
    SCOPES.canViewPreOnboarding,
    SCOPES.canViewLosDetails,
    SCOPES.canViewHrForms,
    SCOPES.canViewOpsDocUpload
  ],
  0: [SCOPES.canViewReports, SCOPES.canViewLeads, SCOPES.canViewCollection,SCOPES.canViewZohoMIS,SCOPES.canViewHrForms],
  1: [SCOPES.canViewReports, SCOPES.canViewMIS, SCOPES.canViewLeads, SCOPES.canViewCollection, SCOPES.canViewZohoMIS,SCOPES.canViewHrForms],
  2: [SCOPES.canViewReports, SCOPES.canViewCollection,SCOPES.canViewHrForms],
  3: [SCOPES.canViewReports, SCOPES.canViewMIS, SCOPES.canViewLeads, SCOPES.canViewCollection, SCOPES.canViewPDD,SCOPES.canViewZohoMIS,SCOPES.canViewHrForms],
  4: [SCOPES.canViewReports, SCOPES.canViewCollection, SCOPES.canViewCMATickets,SCOPES.canViewHrForms],
  // ops
  5: [SCOPES.canViewReports, SCOPES.canViewMIS, SCOPES.canViewCollection, SCOPES.canViewCMATickets, SCOPES.canViewLeads, SCOPES.canViewPDD,SCOPES.canViewHrForms,SCOPES.canViewOpsDocUpload],
  6: [SCOPES.canViewCMATickets,SCOPES.canViewHrForms],
  7: [SCOPES.canViewInventory,SCOPES.canViewHrForms],
  11: [SCOPES.canViewAdmin,SCOPES.canViewHrForms],
  12: [SCOPES.canViewDigitalJourney, SCOPES.canViewCMATickets,SCOPES.canViewHrForms],
  // Assistant Collection Manager or Area collection manager
  13: [SCOPES.canViewCollection,SCOPES.canViewMIS,SCOPES.canViewHrForms],
  // Human resources
  14: [SCOPES.canViewBankVerification,SCOPES.canViewPreOnboarding,SCOPES.canViewReports,SCOPES.canViewHrForms],
  // Product
  15: [SCOPES.canViewReports, SCOPES.canViewLeads, SCOPES.canViewCollection,SCOPES.canViewZohoMIS,SCOPES.canViewHrForms],
  // External
  16: [SCOPES.canViewReports,SCOPES.canViewHrForms],
  // only for forms
  17: [SCOPES.canViewHrForms],
  // for oxyzo
  18:[SCOPES.canViewHrForms],
  // READ_ONLY: view/download access across all portal modules; backend blocks mutations.
  19: [
    SCOPES.canViewCollection,
    SCOPES.canViewReports,
    SCOPES.canViewMIS,
    SCOPES.canViewLeads,
    SCOPES.canViewCMA,
    SCOPES.canViewInventory,
    SCOPES.canViewCMATickets,
    SCOPES.canViewDigitalJourney,
    SCOPES.canViewPDD,
    SCOPES.canViewBankVerification,
    SCOPES.canViewPreOnboarding,
    SCOPES.canViewLosDetails,
    SCOPES.canViewHrForms,
    SCOPES.canViewOpsDocUpload
  ]
}
